//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const negativePoints = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getnegativePointsList(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/negative-points/get-negative-points?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


  async function negativdetails(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/negative-points/get-view-details?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function search(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/negative-points/search?query=${encodeURIComponent(query)}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function productFilter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/negative-points/product-filter?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function getHistoryApi(values) {
    try {
        const obj = {
            method: "GET",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json"                
            },
        };
        let query;
        query = JSON.stringify(values);
        let res = await fetch(
            `${config.host}/cdr-panel/negative-points/get-history?query=${query}`,
            obj
        );
        return handleResponse(res);
    }
    catch (err) {
        handleError(err)
    }
}
  async function sendEmail(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/negative-points/send-mail`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function negativePointsExport(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/negative-points/export`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function getAuditHistoryApi(values) {
    try {
        const obj = {
            method: "GET",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json"                
            },
        };
        let query;
        query = JSON.stringify(values);
        let res = await fetch(
            `${config.host}/cdr-panel/negative-points/get-Audit-history?query=${query}`,
            obj
        );
        return handleResponse(res);
    }
    catch (err) {
        handleError(err)
    }

  
}


  return {
    getnegativePointsList,
    search,
    productFilter,
    sendEmail,
    getHistoryApi,
    negativePointsExport,
    getAuditHistoryApi,
    negativdetails
  };
};

export default negativePoints;
